module.exports = __webpack_public_path__ + "pinIco.png?c564ce4e4945900a347e81f96d1ddb13";